<template>
  <section>
    <v-tabs
      v-model="tab"
      grow
    >
      <v-tab>
        Subscription Plan
      </v-tab>
      <v-tab>
        Physical Card
      </v-tab>
      <v-tab>
        Scheduled Allowance
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item
      >

        <v-container>
              <v-row>
                <v-col>
                  <v-card
                  class="mx-auto"
                  max-width="344"
                  outlined
                  >
                    <v-card-title>Basic</v-card-title>
                    <v-card-text>Pay as you Go
                      
                      <br/>free virtual debit card
                      <br/>0.5% fee per transaction</v-card-text>
                    <!--<v-card-actions>
                    <v-btn
                    outlined
                    rounded
                    @click="select_type('video')"
                    >
                    Select
                    </v-btn>
                    </v-card-actions>-->
                  </v-card>
                </v-col>
                <v-col>
                  <v-card
                  class="mx-auto"
                  max-width="344"
                  outlined
                  >
                    <v-card-title>Gold</v-card-title>
                    <v-card-text>
                      
                      <br/>physical debit card
                      <br/>scheduled allowances</v-card-text>
                    <!--<v-card-actions>
                    <v-btn
                    outlined
                    rounded
                    @click="select_plan('video')"
                    >
                    Select
                    </v-btn>
                    </v-card-actions>-->
                  </v-card>
                </v-col>
              </v-row>
        </v-container>

        <v-select v-for="child in child_plans"
        :key="child.id"
        :items="subscription_plans"
        :label="child.name"
        v-model="child.subscription_plan"
        ></v-select>

        <v-btn
          color="success"
          type="submit"
          :loading="loading"
          @click="save_subscriptions"
        >Save</v-btn>

        <br/>
        <br/>
        <br/>
        <div v-show="show_checkout" id="stripe-checkout" class="col-md-6 custom-card-design">
          <v-alert type="success" dismissible v-show="alert_success">
            Your card has been charged successfully.
          </v-alert>
          <v-alert type="error" dismissible v-show="alert_error">
            We were unable to charge your card - please contact support.
          </v-alert>
          <form action="" method="post" id="payment-form">

            <v-text-field
              v-model="charge_amount"
              label="Total to be Billed to your Card"
              type="number"
              readonly
              prefix="$"
            />
            <br/>

            <label for="card-element" class="credit-text">
              <label class="currency-text">We accept all major debit/credit cards in 135+ currencies.</label>
            </label>
            <br/>
            <div id="card-element">
              <!-- a Stripe Element will be inserted here. -->
            </div>

            <!-- Used to display Element errors -->
            <div id="card-errors" role="alert"></div>

            <br/>
            <br/>
            <v-btn
              color="success"
              type="submit"
              :loading="pending_card_charge"
              id='submit_payment'
            >Submit Payment</v-btn>
            <br/>
          </form>
        </div>
      </v-tab-item>
      <v-tab-item>
        <v-select
          :items="children"
          label="Select a Child"
          v-model="selected_child_customer_id"
        ></v-select>
        Ship Card To

        <v-text-field
          v-model="shipping_address.line1"
          label="Address line 1"
        />
        <v-text-field
          v-model="shipping_address.line2"
          label="Address line 2"
        />
        <v-text-field
          v-model="shipping_address.city"
          label="City"
        />
        <v-text-field
          v-model="shipping_address.state"
          label="Province"
        />
        <v-text-field
          v-model="shipping_address.postal_code"
          label="Postal Code"
        />
        <v-select
          :items="country_codes"
          label="Country"
          v-model="shipping_address.country_code"
        ></v-select>

        <v-btn
          color="success"
          type="submit"
          :loading="loading"
          @click="ship_card"
        >Submit</v-btn>
      </v-tab-item>
      <v-tab-item>
        <v-select
          :items="children"
          label="Select a Child"
          v-model="selected_child_customer_id"
        ></v-select>
        Allowance

        <v-text-field
          v-model="amount"
          label="Amount"
          type="number"
          step="1"
          prefix=""
        />
        <v-switch
          v-model="fund_account_if_insufficient"
          label="Fund my account if I have an insufficient balance"
        ></v-switch>
        <v-select
          :items="frequency_items"
          label="Frequency"
          v-model="frequency"
        ></v-select>
        <v-select
          :items="day_of_week_items"
          label="Day of Week to Send On"
          v-model="day_of_week"
        ></v-select>
        <v-text-field
          v-model="date_of_month"
          label="Date of month to send on"
          type="number"
          step="1"
          prefix=""
        />
        <v-switch
          v-model="enabled_flag"
          label="Enabled"
        ></v-switch>
        <v-btn
          color="success"
          type="submit"
          :loading="loading"
          @click="save_allowances"
        >Submit</v-btn>
      </v-tab-item>
    </v-tabs-items>
  </section>
</template>

<script>
var load = require('load-script')

export default {
  props: ['user', 'api_prefix'],
  data: function () {
  return {
    tab: null,
    charge_amount: 0,
    alert_success: false,
    alert_error: false,
    account_balance: null,
    pending_card_charge: false,
    shipping_address: {},
    show_checkout: false,
    date_of_month: null,
    loading: false,
    enabled_flag: false,
    day_of_week: null,
    children: [],
    child_plans: [],
    subscription_plans: [{'text': 'Basic', 'value': 'basic'}, {'text': 'Gold', 'value': 'gold'}],
    country_codes: [{'text': 'Austria', 'value': 'AT'}, {'text': 'Belgium', 'value': 'BE'}, 
    {'text': 'Cyprus', 'value': 'CY'}, {'text': 'Estonia', 'value': 'EE'}, 
    {'text': 'Finland', 'value': 'FI'}, {'text': 'France', 'value': 'FR'},
    {'text': 'Germany', 'value': 'DE'}, {'text': 'Greece', 'value': 'GR'},
    {'text': 'Ireland', 'value': 'IE'}, {'text': 'Italy', 'value': 'IT'},
    {'text': 'Latvia', 'value': 'LV'}, {'text': 'Lithuania', 'value': 'LT'},
    {'text': 'Luxembourg', 'value': 'LU'}, {'text': 'Malta', 'value': 'MT'},
    {'text': 'Netherlands', 'value': 'NL'}, {'text': 'Portugal', 'value': 'PT'},
    {'text': 'Slovakia', 'value': 'SK'}, {'text': 'Slovenia', 'value': 'SI'}, {'text': 'Spain', 'value': 'ES'}, {'text': 'United States', 'value': 'US'}],
    allowances: null,
    frequency: null,
    selected_child_customer_id: null,
    fund_account_if_insufficient: true,
    amount: null,
    frequency_items: ['weekly', 'monthly'],
    day_of_week_items: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
    }
  },
  created: function()
  {
    
  },
  mounted: function()
  {
    let self = this
    window.analytics.page('Settings')
    
    load('https://js.stripe.com/v3/', function (err, script) 
    {
      if (err) 
      {
        // print useful message
      }
      else 
      {
        self.setup_stripe()
        self.get_cards()
      }
    })
  },
  components: {
    
  },
  computed: {
  },
  watch: {
    selected_child_customer_id: function ()
    {
      this.get_allowances()
    },
    children: function (val)
    {
      var amount = 0
      for (child of val)
      {
        if (child.subscription_plan=='gold')
        {
          amount += 5
        }
      }
      this.charge_amount = amount;
    }
  },
  methods: {

    async get_cards()
    {
      let self = this;
      var response = await self.$http.get(self.api_prefix + '/physical_cards',
      {

      });
      if(response.data!=null)
      {
        for (const [key, value] of Object.entries(response.data)) 
        {
          self.children.push({'text': value.name, 'value': key}) 
        }
      }
    },
    async ship_card()
    {
      let self = this;
      var response = await self.$http.post(self.api_prefix + '/physical_cards',
      {
        'shipping_address': self.shipping_address,
        'child_customer_id': self.selected_child_customer_id
      });
      if(response.data!=null)
      {
        console.log(response.data)
      }
    },
    async get_allowances()
    {
      let self = this;
      var response = await self.$http.get(self.api_prefix + '/allowances',
      {

      });
      if(response.data!=null)
      {
        for (const [key, value] of Object.entries(response.data)) 
        {
          if(self.selected_child_customer_id==key)
          {
            if(value.frequency!=null)
            {
              self.frequency = value.frequency
            }
            if(value.fund_account_if_insufficient!=null)
            {
              self.fund_account_if_insufficient = value.fund_account_if_insufficient
            }
            if(value.amount!=null)
            {
              self.amount = value.amount
            }
            if(value.day_of_week!=null)
            {
              self.day_of_week = value.day_of_week
            }
            if(value.date_of_month!=null)
            {
              self.date_of_month = value.date_of_month
            }
            if(value.enabled_flag!=null)
            {
              self.enabled_flag = value.enabled_flag
            }
          }
        }
      }
    },
    async save_allowances()
    {
      let self = this;
      var response = await self.$http.post(self.api_prefix + '/allowances',
      {
        'child_customer_id': self.selected_child_customer_id,
        'amount': self.amount,
        'frequency': self.frequency,
        'fund_account_if_insufficient': self.fund_account_if_insufficient,
        'day_of_week': self.day_of_week,
        'enabled_flag': self.enabled_flag,
        'date_of_month': self.date_of_month
      });
      if(response.data!=null)
      {
        console.log(response.data)
      }
    },
    async get_subscriptions()
    {
      let self = this;
      var response = await self.$http.get(self.api_prefix + '/subscriptions',
      {

      });
      if(response.data!=null)
      {
        self.child_plans = response.data
      }
    },
    async save_subscriptions()
    {
      let self = this;
      var response = await self.$http.post(self.api_prefix + '/subscriptions',
      {
        'child_plans': self.child_plans
      });
      if(response.data!=null)
      {
        console.log(response.data)
      }
    },
    setup_stripe()
    {
      let self = this;
      var stripe = Stripe(process.env.VUE_APP_STRIPE_KEY);
      var elements = stripe.elements();

      var style = {
        base: {
          color: '#32325d',
          lineHeight: '18px',
          fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
          fontSmoothing: 'antialiased',
          fontSize: '16px',
          '::placeholder': {
            color: '#aab7c4'
          }
        },
        invalid: {
          color: '#fa755a',
          iconColor: '#fa755a'
        }
      };

      var card = elements.create('card', {style: style});

      // Add an instance of the card Element into the `card-element` <div>
      card.mount('#card-element');

      card.addEventListener('change', function(event) {
        var displayError = document.getElementById('card-errors');
        if (event.error) {
          displayError.textContent = event.error.message;
        } else {
          displayError.textContent = '';
        }
      });

      // Create a token or display an error when the form is submitted.
      var form = document.getElementById('payment-form');
      form.addEventListener('submit', function(event)
      {
        event.preventDefault();

        stripe.createToken(card).then(function(result)
        {
          if (result.error)
          {
            // Inform the customer that there was an error
            var errorElement = document.getElementById('card-errors');
            errorElement.textContent = result.error.message;
          }
          else
          {
            // Send the token to your server
            self.stripeTokenHandler(result.token);
          }
        });
      });
    },
    async stripeTokenHandler(stripe_token)
    {
      let self = this;

      // Insert the token ID into the form so it gets submitted to the server
      var form = document.getElementById('payment-form');
      var hiddenInput = document.createElement('input');
      hiddenInput.setAttribute('type', 'hidden');
      hiddenInput.setAttribute('name', 'stripeToken');
      hiddenInput.setAttribute('value', stripe_token.id);
      form.appendChild(hiddenInput);

      self.pending_card_charge = true

      try
      {
        var response = await self.$http.post(self.api_prefix + '/process_payment',
        {
          stripe_token: stripe_token,
          charge_amount: self.charge_amount,
          receipt_email: self.user.email,
          full_name: self.user.displayName
        },
        {
          'headers': {'Authorization': self.token}
        });
        console.log(response);
        if(response.data==true)
        {
          self.alert_error = false;
          self.alert_success = true;
          self.$emit('account_balance_updated', self.account_balance);
        }
        else
        {
          self.alert_error = true;
          self.alert_success = false;
        }
        self.pending_card_charge = false;
      }
      catch (error)
      {
        self.alert_error = true;
        self.alert_success = false;
      }
    },
  }
}
</script>

<style scoped>
#stripe-checkout
{
  border-top: 1px solid black;
  padding-top: 5px;
}

#card-element
{
  width: 100%;
}

.StripeElement {
  background-color: white;
  height: 40px;
  padding: 5px 12px;
  border-radius: 4px;
  border: 1px solid transparent;
  box-shadow: 0 1px 3px 0 #e6ebf1;
  -webkit-transition: box-shadow 150ms ease;
  transition: box-shadow 150ms ease;
}

.StripeElement--focus {
  box-shadow: 0 1px 3px 0 #cfd7df;
}

.StripeElement--invalid {
  border-color: #fa755a;
}

.StripeElement--webkit-autofill {
  background-color: #fefde5 !important;
}
</style>
